import React from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ApiConstant } from '../../../../Assets/Constants/ApiConstants';
import { Constent } from '../../../../Assets/Constants/Constent';
import { RightArrowIcon } from '../../../../Assets/Images/CelcomSvgImages';
import { selectedWorkOrderItem } from '../../../../ReduxFeature/StateFeatures/WorkOrderDataState';
import { AppoinmentSubTypeConverter, AppoinmentTypeConverter, GetSummeryAssignedToValue, SummeryInstallerAssignedTo } from '../../../Common/GenericFunctions';

const WorkOrderSummaryCard = ({ data, status }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userDataObj = useSelector((state) => state.userDataInfo?.userData);
  	console.log("in work order summary card :::", data);
    return (
        <div className='workorder-card-section'>
            <div className="wrapper-workorder-card-section">
                <div className="workorder-card-item-section" onClick={() => {
                    dispatch(selectedWorkOrderItem(data))
                    navigate("/workorderdetails");
                }}>
                    <div className="wrapper-workorder-card-item-group">
                        <div className="card-item-group">
                            <div className="card-item-title">
                                {Constent.WORK_ORDER_CARD_ITEM_TITLE1}
                            </div>
                            <div className="card-item-value">
                                {data?.id?.replaceAll("FieldActivity-", "") || "-"}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="workorder-card-item-section" onClick={() => {
                    dispatch(selectedWorkOrderItem(data))
                    navigate("/workorderdetails");
                }}>
                    <div className="workorder-card-item-group">
                        <div className="card-item-group">
                            <div className="card-item-title">
                                {Constent.WORK_ORDER_CARD_ITEM_TITLE2}
                            </div>
                            <div className="card-item-value">
							{/*{AppoinmentTypeConverter({ type: data?.itemTypeId?.replaceAll("_", " ") || "-" })}*/}
							{AppoinmentTypeConverter({ type: data?.problemCategory?.subCategoryId?.replaceAll("_", " ") || "-"})}
                            </div>
                        </div>
                        <div className="card-item-group">
                            <div className="card-item-title">
                                {Constent.WORK_ORDER_CARD_ITEM_TITLE3}
                            </div>
                            <div className="card-item-value">
                                {AppoinmentSubTypeConverter({
                                    subType:
                                        data?.problemCategory?.subCategoryId?.includes(ApiConstant.WOKR_ORDER_OST_TYPE) ?
                                            data?.problemCategory?.typeId?.replaceAll(ApiConstant.WOKR_ORDER_OST_TYPE_MAP, "")
                                            :
                                            data?.problemCategory?.typeId?.replaceAll(data?.problemCategory?.subCategoryId, "")?.replaceAll("_", " ") || "-" ,
                                    type: data?.problemCategory?.subCategoryId?.replaceAll("_", " ") || "-" 
                                })}
                            </div>

                        </div>
                    </div>
                    <div className="workorder-card-item-group">
                        <div className="card-item-group">
                            <div className="card-item-title">
                                {Constent.WORK_ORDER_CARD_ITEM_TITLE4}
                            </div>
                            <div className="card-item-value">
                                {data?.resolutionDate || "-"}
                            </div>
                        </div>
                        <div className="card-item-group">
                            <div className="card-item-title">
                                {Constent.WORK_ORDER_CARD_ITEM_TITLE5}
                            </div>
                            <div className="card-item-value">
                                {data?.description?.substring(
                                    data?.description?.indexOf("DistStrt") + 9,
                                    data?.description?.indexOf("DistEnd")
                                ) || "-"}
                            </div>
                        </div>
                    </div>
                    {userDataObj?.activeUserData?.userRole === Constent.ADMIN_ROLE ? (
                        <>
                            <div className="workorder-card-item-group">
                                <div className="card-item-group">
                                    <div className="card-item-title">
                                        {Constent.WORK_ORDER_CARD_ITEM_TITLE14}
                                    </div>
                                    <div className="card-item-value">
                                        {GetSummeryAssignedToValue(data)}
                                    </div>
                                </div>
                                <div className="card-item-group">
                                    <div className="card-item-title">
                                        {Constent.WORK_ORDER_CARD_ITEM_TITLE6}
                                    </div>
                                    <div className="card-item-value">
                                        {SummeryInstallerAssignedTo(data)}
                                    </div>
                                </div>
                            </div>
                            <div className="workorder-card-item-group">
                                <div className="card-item-group">
                                    <div className="card-item-title">
                                        {Constent.WORK_ORDER_CARD_ITEM_TITLE7}
                                    </div>
                                    <div className="card-item-value">
                                        {status || "-"}
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : (<div className="workorder-card-item-group supervisor-grid">
                        <div className="card-item-group">
                            <div className="card-item-title">
                                {Constent.WORK_ORDER_CARD_ITEM_TITLE6}
                            </div>
                            <div className="card-item-value">
                                {data?.assignedTo?.split(" ")[0] || "-"}
                            </div>
                        </div>
                        <div className="card-item-group">
                                    <div className="card-item-title">
                                        {Constent.WORK_ORDER_CARD_ITEM_TITLE7}
                                    </div>
                                    <div className="card-item-value">
                                        {status || "-"}
                                    </div>
                                </div>
                    </div>
                    )}
                </div>
                <div className="workorder-card-item-section" role="button" onClick={() => {
                    dispatch(selectedWorkOrderItem(data))
                    navigate("/workorderdetails");
                }}>
                    <RightArrowIcon stroke={"#009BDF"} />
                </div>
            </div>
        </div>
    )
}

export default WorkOrderSummaryCard;